<template>
	<!--风险告知函提示框-->
	<div class="model-container animated-5 fadeIn" v-if="showModel">
		<div class="model-box posi-relative">
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<!--标题-->
				<span class="mdl-title"><span v-if="imgList && imgList.length && isShowCPGY" style="color:#333;!important">基金产品资料概要及</span>基金投资风险告知函</span>
				<!--关闭按钮-->
				<span @click="$emit('modelCancle')">X</span>
			</p>
			<!-- 主要内容 -->
			<div class="model-content flex-dire-btw gd">
                <div>
                    <div v-if="isShowCPGY">
                        <p v-for="(item,index) in imgList" :key="index">
                            <img :src="item.filePath" style="max-width:100%;">
                        </p>
                    </div>
					<p>尊敬的基金投资人：</p>
                    <p>基金投资在获取收益的同时存在投资风险，可能会导致本金亏损。为了保护您的合法权益，特向您告知如下风险，请您在投资基金前认真阅读：</p>
                    <p>1、证券投资基金是一种理财工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。基金不同于银行储蓄和债券等能够提供固定收益预期的金融工具，投资人购买基金，既可能按其持有份额分享基金投资所产生的收益，也可能承担基金投资所带来的损失。</p>
                    <p>2、基金在投资运作过程中可能面临各种风险，既包括市场风险，也包括基金自身的管理风险、技术风险和合规风险等。巨额赎回风险是开放式基金所特有的一种风险，即当单个交易日基金的净赎回申请超过基金总份额的百分之十时，投资人将可能无法及时赎回持有的全部基金份额。</p>
                    <p>3、基金投资人应当充分了解基金定期定额投资和零存整取等储蓄方式的区别。基金定期定额投资是引导投资人进行长期投资、平均投资成本的一种简单易行的投资方式，但并不能规避基金投资所固有的风险，不能保证投资人获得收益，也不是替代储蓄的等效理财方式。</p>
                    <p>4、基金管理人承诺以诚实守信、勤勉尽责的原则管理和运用基金资产，但不保证旗下基金一定盈利，也不保证最低收益。旗下基金的过往业绩及其净值高低并不预示其未来业绩表现。基金管理人提醒投资人基金投资的“买者自负”原则，在做出投资决策后，基金运营状况与基金净值变化引致的投资风险，由投资人自行负担。</p>
                    <p>5、本公司将对基金投资人的风险承受能力进行调查和评价，并根据基金投资人的风险承受能力以及产品的风险等级等因素提出适当性匹配意见，但本公司的适当性匹配意见仅供投资者参考，不表明是对产品的风险和收益做出实质性判断或保证，投资人应当在了解产品基本情况、听取本公司意见的基础上，根据自身能力审慎决策，独立承担投资风险。</p>
                    <p>6、基金分为股票型基金、混合型基金、债券型基金、货币市场基金等不同类型，投资人投资不同类型的基金将获得不同的收益预期，也将承担不同程度的风险。一般来说，基金产品的风险评级越高，其可能导致的本金亏损越大。</p>
                    <p>7、关于限制销售对象权利行使期限或者可解除合同期限等全部限制内容，请您重点关注《基金合同》的基金份额的发售、基金份额的申购与赎回、基金合同当事人及权利义务、违约责任、争议的处理和适用的法律等章节，以及《招募说明书》及更新的相应部分，确保在了解情况并愿意承担相应风险的前提下投资。</p>
                    <!-- 只有定投时显示 -->
                    <p v-if="isFixed">8、投资人应当充分了解基金定期定额投资和零存整取等储蓄方式的区别。定期定额投资是引导投资人进行长期投资、平均投资成本的一种简单易行的投资方式。但是定期定额投资并不能规避基金投资所固有的风险，不能保证投资人获得收益，也不是替代储蓄的等效理财方式。</p>
				</div>
				<div class="txt-center mdl-btn-box">
					<btn-middle v-if="isDisable" @click="callnes()" class="btn-disabled" >我已阅读并同意</btn-middle>
                    <btn-middle v-else @click="$emit('agreeFn')">我已阅读并同意</btn-middle>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性
        props:['showModel','isFixed','fundCode','isShowCPGY'],
		data(){
			return{
                imgList:[],
                isDisable:true
			}
        },		 
        watch:{
            showModel(){
                if(this.showModel){
                    let fundCode = this.fundCode || this.$parent.fundCode;
                    if(fundCode){
                        this.imgList = [];
                        this.$axios_post('trade/pre/fund/disclosure',{fundCode:fundCode}).then(res=>{
                            //console.log(res,'001798')
                            if(res.code = "00000000"){
                                if(res.dataList && res.dataList.length>0){
                                    this.imgList = res.dataList[0].fileList;
                                }
                                !this.isShowCPGY ? this.isDisable = false : '';
                                if(this.isShowCPGY){
                                    let that = this, nScrollHight = 0, nScrollTop= 0, nDivHight= 0,imgHeight = 0;
                                    that.$nextTick(() => {
                                        $(".gd>div").scroll(function(){
                                            nScrollHight = $(this)[0].scrollHeight;
                                            nScrollTop = $(this)[0].scrollTop;
                                            nDivHight = $(this).height();
                                            imgHeight = $(this).find('div').height();
                                            // if(nScrollTop + nDivHight + 50 >= nScrollHight){
                                            //     that.isDisable = false;
                                            // }
                                            if(nScrollTop + 50 >= imgHeight){
                                                that.isDisable = false;
                                            }
                                        });
                                    })
                                } 
                            }
                        })
                    }else{
                        this.imgList.length == 0 || !this.isShowCPGY ? this.isDisable = false : '';
                    }
                }else{
                    this.isDisable = true;
                }
            }
        },
		methods:{
              callnes(){
                  this.$store.commit('showErrorInfo', {type: 'fail', msg: '请阅读至底部!'});
              },
              //进入页面初始化判断是否有产品资料概要
              getCPZLGY(fundCode){
                  this.$axios_post('trade/pre/fund/disclosure',{fundCode:fundCode}).then(res=>{
                    if(res.code = "00000000"){
                        if(res.dataList && res.dataList.length>0){
                            this.$emit('update:getProjectMsg',true)
                        }else{
                            this.$emit('update:getProjectMsg',false);
                        }
                    }
                })
              }  
		}
	}
</script>

<style scoped lang='less'>
	.model-container{
        display: block;
      
        .model-box{ 
            width:30rem;
            top:15%; 
            .model-content{ 
                padding-top:.5rem;
                padding-right:.35rem;
                >div:first-child{
                    height:15rem;
                    overflow: auto;
                }
                p{ 
                    padding-right:.3rem;
                    line-height: 1.2rem;
                }
                button{ 
                    margin-top:1rem; 
                    width: 11rem;
                }
            }
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/modelCommFxgzh.vue